import React from 'react';
import { Button, Stack } from '@mui/material';
import { useAppDispatch } from '../../../../../app/hooks';
import { closeRuleModal } from '../../../../../services/ContractService/contractSlice';

interface RuleCommandsProps {
  isNewRule: boolean;
  saveCommand: () => void;
  deleteCommand: () => void;
}

const RuleCommands: React.FC<RuleCommandsProps> = ({ 
  isNewRule, 
  saveCommand, 
  deleteCommand 
}) => {
  const dispatch = useAppDispatch();

  const handleSave = () => {
    saveCommand();
    dispatch(closeRuleModal());
  };

  const handleDelete = () => {
    deleteCommand();
    dispatch(closeRuleModal());
  };

  return (
    <>
      {!isNewRule && (
        <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }}>
          <Button color="error" onClick={handleDelete}>
            Delete
          </Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Stack>
      )}
      {isNewRule && (
        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </Stack>
      )}
    </>
  );
};

export { RuleCommands };